/**
 * Marca de una tarea cerrada: «Hecha» (verde, con check) o «Descartada» (gris, con círculo tachado).
 * Va en la tarjeta de la columna «Cerradas», en la lista, en «Tareas parecidas» y en el aviso del buscador.
 * Para una tarea abierta, `EstadoTarea` muestra el nombre del estado como chip.
 */
import { ETIQUETA_ESTADO, esEstadoCerrado, type Estado } from '@cdtec-backlog/contrato';
import { Icono } from '../../componentes/Icono';
import './MarcaCierre.css';

export function MarcaCierre({ estado }: { estado: 'HECHO' | 'DESCARTADA' }) {
  const hecha = estado === 'HECHO';
  return (
    <span className={`cierre ${hecha ? 'cierre--hecha' : 'cierre--descartada'}`}>
      <Icono nombre={hecha ? 'check' : 'prohibido'} tamano={12} />
      {hecha ? 'Hecha' : 'Descartada'}
    </span>
  );
}

/** El estado de cualquier tarea: la marca si está cerrada; si no, un chip con el nombre del estado. */
export function EstadoTarea({ estado }: { estado: Estado }) {
  if (esEstadoCerrado(estado)) return <MarcaCierre estado={estado} />;
  return <span className="etiqueta estado-chip">{ETIQUETA_ESTADO[estado]}</span>;
}
